import { useTheme } from "@/context/ThemeContext";
import { Square, Circle } from "lucide-react";

/**
 * Segmented control for choosing global corner radius across the app.
 * Persists via ThemeContext (localStorage). Rounds all cards, inputs,
 * buttons and dialogs when set to "soft".
 */
export default function CornerPicker() {
  const { corners, setCorners } = useTheme();

  const options = [
    { id: "sharp", label: "Sharp", icon: Square, tagline: "Brutalist / editorial" },
    { id: "soft",  label: "Soft",  icon: Circle, tagline: "Friendly / modern" },
  ];

  return (
    <div className="grid grid-cols-2 gap-3" data-testid="corner-picker">
      {options.map((o) => {
        const active = corners === o.id;
        const Icon = o.icon;
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => setCorners(o.id)}
            data-testid={`corner-option-${o.id}`}
            data-active={active ? "1" : "0"}
            className={`text-left border-2 p-4 flex items-center gap-3 transition-all hover:-translate-y-0.5 ${
              active
                ? "border-[var(--peak-accent)] shadow-[4px_4px_0_0_var(--peak-shadow)] peak-glow"
                : "border-[var(--peak-ink)] hover:shadow-[4px_4px_0_0_var(--peak-shadow)]"
            } bg-[var(--peak-surface)]`}
          >
            <div
              className={`w-10 h-10 flex-none flex items-center justify-center ${
                active ? "bg-[var(--peak-accent)] text-[var(--peak-accent-contrast)]" : "bg-[var(--peak-ink)] text-white"
              }`}
              style={{ borderRadius: o.id === "soft" ? 10 : 0 }}
            >
              <Icon className="w-5 h-5" strokeWidth={2.5} />
            </div>
            <div className="min-w-0">
              <div className="font-heading font-black tracking-tight text-base leading-tight text-[var(--peak-ink)]">
                {o.label}
              </div>
              <div className="text-[10px] font-mono uppercase tracking-[0.15em] text-[var(--peak-muted)] mt-1">
                {o.tagline}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
